// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__Bzq8l","title":"Tab_title__zLeZL"};